import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { FormErrorService } from '../services/form-error.service';
import { catchError, throwError } from "rxjs";
import { ToastService } from "@core/services/toast.service";

export const ErrorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const formErrorService = inject(FormErrorService);
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 0:
          // Hálózati hiba
          console.error('Network error:', error);
          break;
        case 400:
          if (error.error?.validationErrors) {
            formErrorService.applyValidationErrors(error.error.validationErrors);
          } else {
            toastService.message(`Hiba: ${error.message}`, {type: 'danger'});
          }
          break;
        case 401:
          // Do nothing
          break;
        case 404:
          toastService.message(`Az oldal nem található!`, {type: 'danger'});
          break;
        case 500:
          toastService.message(`Szerver hiba: ${error.message}`, {type: 'danger'});
          break;
        default:
          toastService.message(`Ismeretlen hiba (${error.status}): ${error.message}`, {type: 'danger'});
      }

      return throwError(() => error);
    })
  );
};
